<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-subscription-price-dialog-form">
    <mat-form-field *ngIf="data.isNew">
      <mat-label>Subscription Type</mat-label>
      <mat-select
        name="data.reportSubscriptionPrice.reportSubscriptionTypeId"
        [(ngModel)]="data.reportSubscriptionPrice.reportSubscriptionTypeId"
        (selectionChange)="selectedSubscriptionTypeChanged()"
      >
        <mat-option *ngFor="let subscriptionType of data.reportSubscriptionTypes"
                    [value]="subscriptionType.reportSubscriptionTypeId">{{ subscriptionType.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <ng-conainer *ngIf="!data.isNew">
      <mat-label>Subscription Type</mat-label>
      <div>
        <ng-container *ngFor="let subscriptionType of data.reportSubscriptionTypes">
          <ng-container *ngIf="subscriptionType.reportSubscriptionTypeId == data.reportSubscriptionPrice.reportSubscriptionTypeId">
            {{ subscriptionType.name }}
          </ng-container>
        </ng-container>
      </div>
    </ng-conainer>
    <br />
    <mat-form-field *ngIf="data.isNew">
      <mat-label>Level</mat-label>
      <mat-select
        name="data.reportSubscriptionPrice.reportSubscriptionLevelId"
        [(ngModel)]="data.reportSubscriptionPrice.reportSubscriptionLevelId"
      >
        <mat-option *ngFor="let subscriptionLevel of filteredSubscriptionLevels"
                    [value]="subscriptionLevel.reportSubscriptionLevelId">{{ subscriptionLevel.description }}</mat-option>
      </mat-select>
    </mat-form-field>
    <ng-conainer *ngIf="!data.isNew">
      <mat-label>Level</mat-label>
      <div>
        <ng-container *ngFor="let subscriptionLevel of data.reportSubscriptionLevels">
          <ng-container *ngIf="
              subscriptionLevel.reportSubscriptionLevelId == data.reportSubscriptionPrice.reportSubscriptionLevelId &&
              subscriptionLevel.reportSubscriptionTypeId == data.reportSubscriptionPrice.reportSubscriptionTypeId
            ">
            {{ subscriptionLevel.description }}
          </ng-container>
        </ng-container>
      </div>
    </ng-conainer>
    <br />
    <mat-form-field *ngIf="data.isNew">
      <mat-label>Period Type</mat-label>
      <mat-select name="data.reportSubscriptionPrice.periodTypeId" [(ngModel)]="data.reportSubscriptionPrice.periodTypeId">
        <mat-option *ngFor="let subscriptionPeriod of data.subscriptionPeriodTypes"
                    [value]="subscriptionPeriod.periodTypeId">{{ subscriptionPeriod.description }}</mat-option>
      </mat-select>
    </mat-form-field>
    <ng-conainer *ngIf="!data.isNew">
      <mat-label>Period Type</mat-label>
      <div>
        <ng-container *ngFor="let subscriptionPeriod of data.subscriptionPeriodTypes">
          <ng-container *ngIf="subscriptionPeriod.periodTypeId == data.reportSubscriptionPrice.periodTypeId">
            {{ subscriptionPeriod.description }}
          </ng-container>
        </ng-container>
      </div>
    </ng-conainer>
    <br />
    <mat-form-field>
      <mat-label>Price</mat-label>
      <input
        matInput
        name="data.reportSubscriptionPrice.price"
        type="number"
        [(ngModel)]="data.reportSubscriptionPrice.price"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Custom Terms (NET 15 if empty, full terms otherwise: NET 45, --NOT-- 45)</mat-label>
      <input
        matInput
        name="data.customTerms"
        [(ngModel)]="data.reportSubscriptionPrice.customTerms"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Tax (In Decimal: 0.0725 = 7.25%, blank = no tax)</mat-label>
      <input
        matInput
        type="number"
        step="0.00001"
        name="data.tax"
        [(ngModel)]="data.reportSubscriptionPrice.taxRate"
      /> </mat-form-field
    ><br />
    <ng-container>
      <mat-checkbox name="data.reportSubscriptionPrice.suppressInvoice" [(ngModel)]="data.reportSubscriptionPrice.suppressInvoice">Suppress Invoice?</mat-checkbox>
    </ng-container><br />
    <ng-container *ngIf="!data.isNew">
      <mat-checkbox name="data.clearProposal" [(ngModel)]="data.clearProposal">Clear Proposal?</mat-checkbox>
    </ng-container>
    <br />
    <ng-container>
      <mat-label>Proposal File: ({{ data.reportSubscriptionPrice.proposalId }})</mat-label>
      <input
        type="file"
        id="inputFile"
        (change)="handleFileInput($event.target.files)"
      />
    </ng-container>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Subscription Price
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
